// HTTP layer — Supabase client + fetchJson wrapper
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL =
  import.meta.env?.VITE_SUPABASE_URL ||
  'https://hbrvoairynwsliyxxgsg.supabase.co';
const SUPABASE_ANON_KEY =
  import.meta.env?.VITE_SUPABASE_ANON_KEY ||
  'sb_publishable_a0ZR31NQNuDyXgm8uqoQ0g_DW96AQLB';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    storageKey: 'zzy_session',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  }
});

const REST_BASE = `${SUPABASE_URL}/rest/v1`;

async function buildHeaders(extra = {}) {
  let jwt = null;
  try {
    const { data } = await supabase.auth.getSession();
    jwt = data?.session?.access_token || null;
  } catch (_) { /* ignore */ }
  return {
    'apikey': SUPABASE_ANON_KEY,
    'Authorization': `Bearer ${jwt || SUPABASE_ANON_KEY}`,
    'Content-Type': 'application/json',
    ...extra
  };
}

/**
 * Wrapper genérico para PostgREST + RPC.
 * @param {string} path     '/vw_briefing_executivo?select=*&limit=1'
 * @param {object} opts     { method?, body?, headers? }
 */
export async function fetchJson(path, opts = {}) {
  const url = path.startsWith('http')
    ? path
    : `${REST_BASE}${path.startsWith('/') ? path : '/' + path}`;

  const headers = await buildHeaders(opts.headers);
  const ctrl = AbortSignal.timeout?.(20_000);

  const res = await fetch(url, {
    method: opts.method || 'GET',
    headers,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
    signal: ctrl
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const err = new Error(`HTTP ${res.status}${text ? ' · ' + text.slice(0, 200) : ''}`);
    err.status = res.status;
    err.url = url;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

export const SUPABASE = { url: SUPABASE_URL, anonKey: SUPABASE_ANON_KEY };
